import http from '@/services/api/http';

export default {
  getPlayerLeaderboards() {
    return http.get('api/Profile/leaderboards');
  },
  getLeaderboards() {
    const url = process.env.USE_API_WRAPPER ?
      'api/Public/GetLiveData?url=/api/Leaderboards' :
      'api/Leaderboards';
    return http.get(url);
  },
  getLeaderboard({ id, dateRange = 7, page = 1, itemsPerPage = 30 }) {
    const encoded = encodeURIComponent(`?daterange=${dateRange}&page=${page}&itemsPerPage=${itemsPerPage}`);
    const url = process.env.USE_API_WRAPPER ?
      `api/Public/GetLiveData?url=/api/Leaderboards/${id}${encoded}` :
      `api/Leaderboards/${id}?daterange=${dateRange}&page=${page}&itemsPerPage=${itemsPerPage}`;
    return http.get(url);
  },
};



// WEBPACK FOOTER //
// ./src/services/api/leaderboards.js